<template>
  <div class="ksm-modus__vergleich-wrapper">
    <split-layout
      :cols="3"
      :sidebar_left_collapse="sidebar_left_collapse"
      :sidebar_right_collapse="sidebar_right_collapse"
    >
      <!-- spit-layout sidebar 1 -->
      <div slot="sidebar-1" class="ksm-flex-1" style="position:relative;">
        <sidebar-view
          :merz="merz"
          @changeSeite="changeSeite"
          :modusOption="modusOption"
          :sidebarPageStyle="'margin: 10px 20px 10px 15px'"
          :seiteIdx="seiteIdx"
        ></sidebar-view>
      </div>
      <!-- split-layout main-->
      <div slot="main-content" class="ksm-texte__modus-main">
        <!-- toolbar -->
        <slot name="modusindex-toolbar"></slot>

        <!-- vergleich main content start -->
        <div class="ksm-modus__vergleich-main">
          <!-- deepzoom 1-->
          <div class="ksm-vergleich-content">
            <deepzoom-view
              @changePage="changeSeite"
              :modusOption="modusOption"
              :seiteIdx="seiteIdx"
              :seiten="seiten"
              key="deep_vergleich_1"
            ></deepzoom-view>
          </div>
          <!-- spliter -->
          <div class="ksm-flex-xy-center" style="width:36px">
            <div style="width:1px; height:100%; background-color:grey"></div>
          </div>
          <!-- deepzoom 2-->
          <div class="ksm-vergleich-content">
            <deepzoom-view
              @changePage="b_changeSeite"
              :modusOption="b_modusOption"
              :seiteIdx="b_seiteIdx"
              :seiten="b_seiten"
              key="deep_vergleich_2"
            ></deepzoom-view>
          </div>
        </div>
        <!-- vergleich main content  end -->
      </div>

      <!-- spit-layout sidebar2 -->
      <div slot="sidebar-2" class="ksm-flex-1" style="position:relative">
        <sidebar-view
          :merz="b_merz"
          :modusOption="b_modusOption"
          @changeSeite="b_changeSeite"
          :seiteIdx="b_seiteIdx"
        ></sidebar-view>
      </div>
    </split-layout>
  </div>
</template>

<script>
import DeepzoomView from "comps/DeepzoomView.vue";
import Thumbnail from "comps/Thumbnail.vue";
import SplitLayout from "comps/SplitLayout.vue";
import Sidebar from "./Sidebar.vue";

import MixinsModus from "comps/mixins/Modus.vue";

export default {
  props: ["viewKey"],
  mixins: [MixinsModus],
  components: {
    "deepzoom-view": DeepzoomView,
    "split-layout": SplitLayout,
    "sidebar-view": Sidebar,
    "foot-thumbnail": Thumbnail
  },
  data() {
    return {
      alleTranscriptionZeigen: false,
      sidebar_left_collapse: true,
      sidebar_right_collapse: true,
      modusId: "vergleichsmodus"
    };
  }
};
</script>

<style lang="scss"
 scoped>
$footerHeight: 150px;

.ksm-modus__vergleich-wrapper {
  @extend .ksm-flex;
  @extend .ksm-content-font;
  justify-content: center;
}

.ksm-modus__vergleich-main {
  @extend .ksm-flex-1;
  @extend .ksm-flex;
  @extend .ksm-texte__modus-body;

  .ksm-vergleich__einfuehrung {
    @extend .ksm-flex-1;
    @extend .ksm-flex-column;
    max-width: 500px;
    padding: 10px;
    .__title {
      background-color: $lightGrey;
      border: 2px solid $darkGrey;
      height: 27px;
      padding: 3px;
    }
    .__body {
      @extend .ksm-flex-1;
      display: block;
      position: relative;
      border: 2px solid $darkGrey;
      border-top-width: 0;
      padding: 10px;
    }
  }
  .ksm-vergleich-content {
    @extend .ksm-flex-1;
  }
}

.ksm-vergleich-footer {
  @extend .ksm-flex-00auto;
  height: $footerHeight;
  @extend .ksm-flex;
  padding-left: 25px;
  padding-right: 10px;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// Vergleich.vue?13cb5251